<template>
  <div v-show="workplace && point" class="desk-preview" :class="{ 'desk-preview--selectable': selectable }" :role="selectable ? 'dialog' : 'tooltip'" :aria-labelledby="selectable ? 'plan-preview-title' : undefined" :style="position" @wheel.stop>
    <template v-if="lastWorkplace">
      <div class="preview-heading">
        <strong id="plan-preview-title">{{ lastWorkplace.place_code }}</strong><span>{{ $t('building.plan.states.' + lastWorkplace.state) }}</span>
        <v-btn v-if="selectable" icon small :aria-label="$t('building.plan.close')" @click="$emit('close')"><v-icon small>mdi-close</v-icon></v-btn>
      </div>
      <div class="preview-people">
        <p v-if="!lastWorkplace.active.length" class="preview-empty">{{ $t('building.plan.noAssignments') }}</p>
        <PlanAssignment v-for="assignment in lastWorkplace.active" :key="assignment.id" :assignment="assignment" :admin="admin" :endpoint="endpoint" />
      </div>
      <div v-if="selectable" class="preview-actions"><v-btn small text color="primary" @click="$emit('select', lastWorkplace)"><v-icon small left>mdi-card-account-details-outline</v-icon>{{ $t('building.plan.openDetails') }}</v-btn></div>
    </template>
  </div>
</template>

<script>
import PlanAssignment from './PlanAssignment';
export default {
  components: { PlanAssignment },
  props: { workplace: Object, admin: Boolean, endpoint: { type: String, required: true }, point: Object, selectable: Boolean },
  data: () => ({ lastWorkplace: null, width: 320, height: 120, viewportWidth: window.innerWidth, viewportHeight: window.innerHeight }),
  watch: {
    workplace: { immediate: true, handler(value) { if (value) this.lastWorkplace = value; } }
  },
  computed: {
    position() {
      if (!this.point) return {};
      const gap = 16, margin = 12;
      const x = this.point.x + gap + this.width <= this.viewportWidth - margin ? this.point.x + gap : this.point.x - gap - this.width;
      const y = this.point.y + gap + this.height <= this.viewportHeight - margin ? this.point.y + gap : this.point.y - gap - this.height;
      return { left: Math.max(margin, Math.min(x, this.viewportWidth - this.width - margin)) + 'px', top: Math.max(margin, Math.min(y, this.viewportHeight - this.height - margin)) + 'px' };
    }
  },
  mounted() {
    this.measure();
    this.resizeObserver = new ResizeObserver(this.measure);
    this.resizeObserver.observe(this.$el);
    window.addEventListener('resize', this.measure);
  },
  beforeDestroy() { this.resizeObserver.disconnect(); window.removeEventListener('resize', this.measure); },
  methods: {
    measure() {
      this.viewportWidth = window.innerWidth; this.viewportHeight = window.innerHeight;
      if (!this.$el.offsetWidth) return;
      this.width = this.$el.offsetWidth; this.height = this.$el.offsetHeight;
    }
  }
};
</script>

<style scoped>
.desk-preview { position: fixed; z-index: 230; width: 320px; max-width: calc(100vw - 24px); max-height: calc(100vh - 24px); max-height: calc(100dvh - 24px); overflow: hidden; pointer-events: none; padding: 12px 16px; border: 1px solid #dfe3e4; border-radius: 6px; background: #fff; box-shadow: 0 4px 16px #0002; text-align: left; }
.desk-preview--selectable { pointer-events: auto; display: flex; flex-direction: column; }
.desk-preview--selectable .preview-people { min-height: 0; overflow-y: auto; }
.preview-heading, .preview-actions { flex-shrink: 0; }
.preview-actions { display: flex; justify-content: flex-end; margin-top: 12px; padding-top: 8px; border-top: 1px solid #e8ebec; }
.preview-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.preview-heading strong { font-size: 14px; overflow-wrap: anywhere; }
.preview-heading span, .preview-empty { font-size: 12px; color: #637076; }
.preview-empty { margin: 12px 0 0; }
.desk-preview ::v-deep .detail-person:last-child { border-bottom: 0; padding-bottom: 0; }
</style>
